import { SubsidiaryModel } from "../../models/Subsidiary";
import { IQuerySubsidiaryRepository } from "../../ports/subsidiary/IQuerySubsidiaryRepository";
import Query from "../Query";

class SubsidiaryQuery
  extends Query<SubsidiaryModel>
  implements IQuerySubsidiaryRepository {}

export default SubsidiaryQuery;
